<template>
        <div class="container-fluid">
            <div class="page-title">
                <h4 v-if="!mobile">Utilisateurs </h4>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-block">
                            <div class="table-overflow">
                                <b-form-input
                                    v-model="filter"
                                    type="search"
                                    placeholder="Saisissez votre recherche"
                                ></b-form-input>
 
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *  -->  
                                <div class="col-md-7 fixed-top m-auto mrg-top-70" v-if="error.permission!=null">
                                    <b-alert
                                        :show="alert.dismissCountDown"
                                        dismissible :variant="error.permission? 'danger' : 'success'"
                                        @dismissed="[alert.dismissCountDown=0,error.permission=null]"
                                        @dismiss-count-down="countDownChanged">
                                        <div class="text-center m-auto pl-4" :class="error.permission? 'text-danger' : 'text-dark'" > 
                                            <span v-if="!error.permission" class="lead"> Les paramètres ont été mis à jour avec succès. </span>
                                            <span v-else class="lead"> {{error.txt}} </span>
                                            <br><hr>
                                            <span>Cette alerte disparaîtra après {{alert.dismissCountDown}} secondes ... </span>
                                        </div>
                                    </b-alert>
                                </div>
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *  -->  

                                <b-table    :fields="fields" 
                                            :items="items" 
                                            :filter="filter"
                                            @filtered="onFiltered"
                                            @row-dblclicked="open_permission_modal"
                                        class='BTable' sticky-header striped no-border-collapse>
                                    <template #cell(name)="data">
                                        <span>
                                            {{data.item.name}}
                                        </span>
                                        <span v-if="data.item.adh.user_groups!=null && data.item.adh.user_groups.length>0" v-bind:id="'affected_group_'+data.item.adh.id" @click="showGroupTooltip('tooltip_group_'+data.item.adh.id)">
                                            <font-awesome-icon icon="fa-solid fa-user-group" />
                                            <b-tooltip v-bind:target="'affected_group_'+data.item.adh.id" placement="auto" v-bind:triggers="mobile==true ? 'click' :'hover'" v-bind:ref="'tooltip_group_'+data.item.adh.id">
                                                <b-list-group class="text-center align-middle no_padding">
                                                    <b-list-group-item  v-for="group in data.item.adh.user_groups" v-bind:key="group.pivot.id" class="p-0 border-0 bg-transparent">
                                                        {{group.name}}
                                                    </b-list-group-item>
                                                </b-list-group>
                                            </b-tooltip>
                                        </span>
                                    </template>

                                    <template #cell(email)="data">
                                        <div class="text-center" :title="emailStatus(data.item.adh.status).title">
                                            {{data.item.email}} 
                                            <i :class="emailStatus(data.item.adh.status).class"> </i>
                                        </div>
                                    </template>

                                    <template #cell(telephone)="data">
                                        <span>
                                            {{data.item.telephone}}
                                        </span>
                                    </template>
                                    
                                    <template #cell(mobile)="data">
                                        <span>
                                            {{data.item.mobile}}
                                        </span>
                                    </template>

                                    <template #cell(role)="data">
                                        <b-list-group>
                                            <b-list-group-item  v-for="struct in data.item.adh.structures" v-bind:key="struct.pivot.id" class="p-0 border-0 bg-transparent">
                                                <span v-if="struct.id==$store.getters.structure_id" class="">
                                                    <span v-if='struct.pivot.role_id==3'>
                                                        Adhérent(e) 
                                                        <span v-if='struct.pivot.code==null'> - </span>
                                                        <span v-else> ( {{struct.pivot.code}} ) </span>
                                                    </span>

                                                    <span v-else-if='struct.pivot.role_id==1'> Responsable</span> 
                                                </span>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </template>

                                    <template #cell(extraction)="data">
                                        <button class="btn btn-icon btn-rounded btn-info" @click="open_extraction_adh(data.item)">
                                            <i class="ti-export"></i>
                                        </button>
                                    </template>

                                </b-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <b-modal ref="permission_popup" hide-footer centered title="Permission"  size="xl">
                <v-user-permission
                    :selected_user="selected_user"
                    :action="action"
                    @user-permission-done = "close_permission_modal"
                ></v-user-permission>
            </b-modal>

            <b-modal ref='annuler_role' hide-footer centered title="" size="lg">
                <v-annuler-role :selected_user="selected_user" :action="action" @close="close_annuler_role" @hidden="close_annuler_role" :structure_id="$store.getters.structure_id" @AnnulerRole="close_annuler_role" ></v-annuler-role>
            </b-modal>

            <b-modal ref="extraction_popup_adh" hide-footer centered title="Extraction" size="xl">
                <!-- to change the b-modal size size="xl" or size="lg" or size="sm" -->
                <div  class="card border-0 align-items-center" v-for="struct in structure" v-bind:key="struct.id">
                <v-extraction-adh
                    :adherent="selected_user"
                    :start_date="struct.cloture_exercice"
                    :subscriptionOK="true"
                    @extraction-done = "close_extraction_adh">
                    Custom
                </v-extraction-adh>
                </div>
            </b-modal>

        </div>
    
</template>

<script>
    import api from "../../config/_api";
    import { mapGetters } from 'vuex';
    import UserPermission from "../../components/UserPermission.vue";
    import Extraction from "../../components/Extraction/Extraction.vue";
    import AnnulerRole from "../../components/Role/AnnulerRole.vue";
    

    export default {
        name: "Index",
        components:{
            'v-user-permission': UserPermission,
            'v-annuler-role': AnnulerRole,
            'v-extraction-adh' : Extraction,
        },
        data () {
            return {
                selectRole:'Tous', // adherent , responsable 
                action : "index",
                error : {
                    permission : null,
                    txt : "",
                },
                selected_user: null,
                sortBy :"",
                sortDirection :"asc",
                alert : {
                        dismissSecs: 10,
                        dismissCountDown: 0,
                },
                window: {
                    width: 0,
                    height: 0
                },
                mobile: false,
                tdClass : "text-center align-middle",
                thClass : "text-center",

                rows: 1,
                filter: null,
            }
        },
        computed: {
            ...mapGetters({
                structure : 'structure/structure',
                adherents: 'adherents/adherents',
            }),
            fields(){       //TODO adapt fields
                var fields=[];
                if(this.mobile){
                    fields=[
                        {key :'name', label : 'Nom de l\'utilisateur', sortable: true, thClass: this.thClass, tdClass:  this.tdClass},
                        {key :'email', label : 'Email', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                        {key :'mobile', label : 'Portable', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                        {key :'telephone', label : 'Téléphone', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                        {key :'role', label : 'Rôle', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                        {key :'extraction', label : 'Extraction', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                    ];
                }
                else {
                    fields=[
                    {key :'name', label : 'Nom de l\'utilisateur', sortable: true, thClass: this.thClass, tdClass:  this.tdClass},
                    {key :'email', label : 'Email', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                    {key :'telephone', label : 'Téléphone', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                    {key :'mobile', label : 'Portable', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                    {key :'role', label : 'Rôle', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                    {key :'extraction', label : 'Extraction', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                ];
                }
                return fields;
            },
            items(){        //TODO adapt items
                var items=[];
                        
                var name="" ;
                var code_adh="";
                var code="";
                for (var adh of this.adherents){
                       
                    //Mise en forme du nom du responsable en interne pour que le tri fonctionne
                    if(adh.firstname != null){
                        name = adh.title +" "+ adh.lastname +" "+ adh.firstname;
                    }
                    else{
                        name = adh.title +" "+ adh.lastname;
                    }

                    for(var struct of adh.structures){
                        if(struct.id == this.$store.getters.structure_id){
                            if(struct.pivot.role_id==3){
                                code_adh=struct.pivot.code;
                                code=struct.pivot.code;
                            }
                            if(struct.pivot.role_id==1){
                                code_adh+=" Responsable";
                            }
                        }
                    }
                    items.push(
                    {
                        adh : adh,
                        name : name,
                        email : adh.email,
                        telephone : adh.tel,
                        mobile : adh.mobile,
                        role : code
                    });
                    //RAZ des variables avant le prochain push
                    name="";
                    code_adh = "";
                    code="";
                }
                return items;
            },
        },
        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        mounted() {
            this.$store.dispatch('adherents/getUtilisateurs');
            this.rows = this.adherents.length
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
        methods: {
            emailStatus(Emailstatus){
                var status={
                    title : '',
                    class : ''
                };

                if(Emailstatus==1){
                        status.class="fa fa-check text-success" ; status.title="Cette adresse mail est valide";
                }else if (Emailstatus==0){
                        status.class="fa fa-question text-dark" ;  status.title="Cette adresse mail n'a pas encore été validée";
                }else if (Emailstatus==4){
                    status.class="fa fa-hourglass-half" ; status.title="Cette adresse mail est temporaire";
                }else{
                        status.class="fa fa-times text-danger"; status.title="Cette adresse mail n'est pas valide"
                }
                return status;
            },
            countDownChanged(dismissCountDown) {
                this.alert.dismissCountDown = dismissCountDown;
            },
            showAlert() {
                this.alert.dismissCountDown = this.alert.dismissSecs;
            },

            open_extraction_adh(user){
                //Passer le système selectionné à l'enfant
                this.selected_user=user.adh;
                this.$refs.extraction_popup_adh.show();
            },
            close_extraction_adh(){
                this.$refs.extraction_popup_adh.hide();
                this.$store.dispatch('adherents/getUtilisateurs').then(() => {
                    this.sortDirection = '';
                    this.sortBy ='';
                });
            },
            
            RoleStatus(structures){
                var status=0;
                var i=0;
                for (var struct of structures){
                    if(struct.id==this.$store.getters.structure_id){
                        status+=struct.pivot.status;
                        i++;
                    }
                }
                if(status==i){
                    return false;
                }
                return true;
            },
            
            open_annuler_role(user){
                this.action='annuler';
                this.selected_user=user;
                this.$refs.annuler_role.show();
            },
            close_annuler_role(){
                this.selected_user=null;
                setTimeout(function ()  { 
                    this.$store.dispatch('adherents/getUtilisateurs').then(function ()  {
                        this.rows = this.adherents.length
                        this.$forceUpdate();
                    }.bind(this));
                }.bind(this),500);
                this.$refs.annuler_role.hide();
            },

            open_permission_modal(item, index, event) {
                this.action='index';
                this.selected_user=item.adh;

                if(this.RoleStatus(item.adh.structures)){
                    this.$refs.permission_popup.show();
                }
                else{
                    this.open_annuler_role(item.adh);
                }

            },
            close_permission_modal(data){
                
                setTimeout(function ()  { 
                    this.$store.dispatch('adherents/getUtilisateurs').then(function ()  {
                        this.rows = this.adherents.length
                        this.$forceUpdate();
                    }.bind(this));
                }.bind(this),500);
                
                if(data){
                    this.error.permission=data.error;

                    if(data.error){
                        this.error.txt=data.errormsg;
                    }
                    this.$refs.permission_popup.hide();
                    this.showAlert();
                }
                else {
                    this.$refs.permission_popup.hide();
                }
                //this.selected_user=null;
            },
            
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;
                this.mobile=(this.window.width<1080)? true : false ;
            },
            onFiltered(filteredItems) {
                this.rows = filteredItems.length
            },
            showGroupTooltip(groupRef){
                if(this.mobile){
                    var $tooltip = groupRef;
                    this.$refs[groupRef].$emit('open');
                    setTimeout(function ()  { 
                        this.$refs[$tooltip].$emit('close');
                    }.bind(this,$tooltip),1000);
                }
            }
        }
    }
</script>


<style>

.asc:after{
    content: "\25B2"
}

.desc:after{
    content: "\25BC"
}
.alert-fixed{
    position: fixed;
    top: 20px; 
    left:2%;
    width: 96%;
}
.not-allowed{
    cursor : not-allowed,
}

.BTable{
    max-height: 700px;
}
</style>